/** Canonical Inora product mark (`/public/geometric (1).png`). */
export const PRODUCT_LOGO_PATH = "/geometric (1).png";

/** URL-safe path for `next/image`, metadata, and emails. */
export const PRODUCT_LOGO_SRC = "/geometric%20(1).png";

export function getProductLogoUrl(siteOrigin?: string): string {
  if (!siteOrigin) return PRODUCT_LOGO_SRC;
  return `${siteOrigin.replace(/\/$/, "")}${PRODUCT_LOGO_SRC}`;
}
